import React from "react";
import styles from "./Services.module.css";
import Robotics from "../../../assets/images/school_programmes/services/robotics.png";
import AI from "../../../assets/images/school_programmes/AI.png";
import stem from "../../../assets/images/school_programmes/services/stem.png";
import Atl from "../../../assets/images/school_programmes/services/ATL.png";
import makerSpace from "../../../assets/images/school_programmes/services/makerSpace.png";
import assessment from "../../../assets/images/school_programmes/services/assessment.png";
import exchange from "../../../assets/images/school_programmes/services/exchangeprogrammes.png";
import drone from "../../../assets/images/school_programmes/services/drone.png";
import space from "../../../assets/images/school_programmes/services/space.png";
import planetorium from "../../../assets/images/school_programmes/services/planetorium.png";
import ARVR from "../../../assets/images/school_programmes/services/ARVR.png";
import Printing from "../../../assets/images/school_programmes/services/3dPrinting.png";
import MiniRobotics from "../../../assets/images/school_programmes/services/MiniRobotics.png";
import ImpactProgramme from "../../../assets/images/school_programmes/services/ImpactProgramme.jpg";

const Services = () => {
  const services = [
    {
      title: "ROBOTICS PROGRAM",
      grades: "Grade 1 - 12",
      description: [
        <>Young children get hands-on experience with</>,
        <>
          <span style={{ color: "var(--secondary)" }}>Controllers</span>, {""}
          <span style={{ color: "var(--secondary)" }}>Axles</span>, {""}
          <span style={{ color: "var(--secondary)" }}>Motors</span>, {""}
          <span style={{ color: "var(--secondary)" }}>Wires</span> {""}
          and other robotics {""}
          <span style={{ color: "var(--secondary)" }}>equipment</span>
        </>,
        <>
          to understand different aspects of{" "}
          <span style={{ color: "var(--secondary)" }}>Robotics</span> through
          our dedicated lab setup in school
        </>,
      ],
      image: Robotics,
    },
    {
      title: "ARTIFICIAL INTELLIGENCE PROGRAM",
      grades: "Grade 1 - 12",
      description: [
        <>Students learn cutting-edge AI technologies including</>,
        <>
          <span style={{ color: "var(--secondary)" }}>Voice Recognition</span>,{" "}
          {""}
          <span style={{ color: "var(--secondary)" }}>
            Object Detection
          </span>, {""}
          <span style={{ color: "var(--secondary)" }}>
            Machine Learning
          </span>{" "}
          {""}
          and more
        </>,
        <>
          through our state-of-the-art{" "}
          <span style={{ color: "var(--secondary)" }}>AI Lab</span> setup in
          school
        </>,
      ],
      image: AI, // You may want to use a different image for AI
    },
    {
      title: "STEM PROGRAM",
      grades: "Grade 1 - 12",
      description: [
        <>
          Learners get exposed to various
          <span style={{ color: "var(--secondary)" }}>tech</span>
          tech subjects as
        </>,
        <>
          Learn technologies as{" "}
          <span style={{ color: "var(--secondary)" }}>Robotics</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>AI</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>3D Printing</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Space</span>,{" "}
          <span style={{ color: "var(--secondary)" }}> Electronics</span>,
          <span style={{ color: "var(--secondary)" }}> VR Classroom</span>,
        </>,
        <>
          <span style={{ color: "var(--secondary)" }}>Drone Tech</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Space program</span> and
          more through
          <span style={{ color: "var(--secondary)" }}> Stem lab </span>
          set up in school
        </>,
      ],
      image: stem,
    },
    {
      title: "ATAL TINKERING LAB",
      grades: "Grade 6 - 12",
      description: [
        <>
          One Stop Solution for{" "}
          <span style={{ color: "var(--secondary)" }}>ATL Setup</span>.
        </>,
        <>
          End to end execution of{" "}
          <span style={{ color: "var(--secondary)" }}>Atal Tinkering Labs</span>{" "}
          various
        </>,
        <>
          <span style={{ color: "var(--secondary)" }}>STEM-DIY Kits</span>,
          Products & Methodologies. <br />
          Tranche 1,2,3,4 available.
        </>,
      ],
      image: Atl,
    },
    {
      title: "MAKER SPACE & DESIGN Lab",
      grades: "Grade 1 - 12",
      description: [
        <>
          Purely for
          <span style={{ color: "var(--secondary)" }}> IB </span>&
          <span style={{ color: "var(--secondary)" }}> IGCSE Schools.</span>
          <br />
          World class Maker space lab & Design lab with required equipment's
          such as
          <span style={{ color: "var(--secondary)" }}> 3D Printing</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Drone tech</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Electronics</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>AI</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Robotics</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>film making</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>VR Classroom</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Space program</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>Pottery making</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>wood carving</span> and
          more.
        </>,
        <>Maker space and Design Lab set up in school.</>,
      ],
      image: makerSpace, // Add appropriate image path if available
    },
    {
      title: "Assistance and Assessment & Support",
      grades: "Grade 1 - 12",
      description: [
        <>
          Our dedicated team supports in the lab execution. We also help schools
          by using our data-driven process to easily review and document their
          progress periodically.
        </>,
      ],
      image: assessment,
    },
    {
      title: "JAPANESE EXCHANGE PROGRAM",
      grades: "Grade 1 - 12",
      description: [
        <>
          Engage in hands-on activities like origami and anime discussions,
          enhancing your learning experience similar to our{" "}
          <span style={{ color: "var(--secondary)" }}>Robotics</span> and{" "}
          <span style={{ color: "var(--secondary)" }}>AI</span> programs.
        </>,
        <>
          Connect with Japanese students to learn about their traditions,
          history, and way of life, fostering a cultural exchange akin to our
          <span style={{ color: "var(--secondary)" }}> STEM</span> initiatives.
        </>,
        <>
          Enjoy flexible learning that allows you to set your own pace, similar
          to the personalized approach in our{" "}
          <span style={{ color: "var(--secondary)" }}>Maker Space</span> &
          Design Lab.
        </>,
        <>
          Join a global community of students from around the world, enhancing
          the collaborative spirit found in all our programs.
        </>,
      ],
      image: exchange, // Add appropriate image path if available
    },
    {
      title: "STEMx Impact Program",
      grades: "Grade 1 - 12",
      description: [
        <>
          STEMx provides the tech, program management, and execution support to
          help <span style={{ color: "var(--secondary)" }}>CSR</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>NGOs</span>, and{" "}
          <span style={{ color: "var(--secondary)" }}>governments</span> execute
          impactful programs at a large scale. Through their successful
          execution of over 5 projects, STEMx has positively impacted more than{" "}
          <span style={{ color: "var(--secondary)" }}>5000 students</span>.
        </>,
      ],
      image: ImpactProgramme, // Leave image as empty
    },
  ];

  const workshops = [
    {
      title: "DRONE WORKSHOPS",
      grades: "Grade 1 - 12",
      description: [
        <>
          Engage in hands-on learning with{" "}
          <span style={{ color: "var(--secondary)" }}>drones</span> and explore
          their applications in various fields.
        </>,
        <>
          Students will learn about{" "}
          <span style={{ color: "var(--secondary)" }}>drone technology</span>{" "}
          and participate in exciting challenges.
        </>,
      ],
      image: drone, // Add appropriate image path
    },
    {
      title: "SPACE & ASTRONOMY WORKSHOPS",
      grades: "Grade 1 - 12",
      description: [
        <>
          Discover the wonders of the universe through{" "}
          <span style={{ color: "var(--secondary)" }}>
            interactive sessions
          </span>
          and hands-on activities.
        </>,
        <>
          Students will explore topics like{" "}
          <span style={{ color: "var(--secondary)" }}>planets</span>,{" "}
          <span style={{ color: "var(--secondary)" }}>stars</span>, and{" "}
          <span style={{ color: "var(--secondary)" }}>galaxies</span>.
        </>,
      ],
      image: space, // Add appropriate image path
    },
    {
      title: "DOOM PLANETARIUM SHOW",
      grades: "Grade 1 - 12",
      description: [
        <>
          Experience the universe like never before with our{" "}
          <span style={{ color: "var(--secondary)" }}>planetarium show</span>,
          showcasing stunning visuals and engaging narratives.
        </>,
      ],
      image: planetorium, // Add appropriate image path
    },
    {
      title: "AR/VR WORKSHOPS",
      grades: "Grade 1 - 12",
      description: [
        <>
          Dive into the world of{" "}
          <span style={{ color: "var(--secondary)" }}>Augmented Reality</span>{" "}
          and <span style={{ color: "var(--secondary)" }}>Virtual Reality</span>{" "}
          with hands-on projects and experiences.
        </>,
      ],
      image: ARVR, // Add appropriate image path
    },
    {
      title: "3D PRINTING WORKSHOPS",
      grades: "Grade 1 - 12",
      description: [
        <>
          Learn the fundamentals of{" "}
          <span style={{ color: "var(--secondary)" }}>3D printing</span> and
          create your own designs.
        </>,
        <>
          Students will explore the entire process from{" "}
          <span style={{ color: "var(--secondary)" }}>designing</span> to{" "}
          <span style={{ color: "var(--secondary)" }}>printing</span>.
        </>,
      ],
      image: Printing, // Add appropriate image path
    },
    {
      title: "MINI ROBOTICS CHALLENGES",
      grades: "Grade 1 - 12",
      description: [
        <>
          Participate in exciting{" "}
          <span style={{ color: "var(--secondary)" }}>robotics challenges</span>
          that encourage teamwork and creativity.
        </>,
        <>
          Students will build and program their own robots to complete tasks.
        </>,
      ],
      image: MiniRobotics, // Add appropriate image path
    },
  ];

  return (
    <section id="services" className={styles.servicesSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle} data-aos="fade-up">
          Our Complete <span>School Services</span>
        </h2>
        <h3 className={styles.subtitle} data-aos="fade-up" data-aos-delay="100">
          [A] STEMx integrated programmes as part of school curriculum
        </h3>

        <div className={styles.servicesGrid}>
          {services.map((service, index) => (
            <div key={index} className={styles.serviceCard}>
              <div className={styles.serviceImageContainer}>
                <img
                  src={service.image}
                  alt={service.title}
                  className={styles.serviceImage}
                />
              </div>
              <div className={styles.serviceContent}>
                <h4 className={styles.serviceTitle}>{service.title}</h4>
                <p className={styles.serviceGrades}>{service.grades}</p>
                <div className={styles.serviceDescription}>
                  {service.description.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <h3
          className={styles.subtitle1}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          [B] STEMx short term Workshops & Camps at schools:
        </h3>
        <div className={styles.servicesGrid}>
          {workshops.map((workshop, index) => (
            <div key={index} className={styles.serviceCard}>
              <div className={styles.serviceImageContainer}>
                <img
                  src={workshop.image}
                  alt={workshop.title}
                  className={styles.serviceImage}
                />
              </div>
              <div className={styles.serviceContent}>
                <h4 className={styles.serviceTitle}>{workshop.title}</h4>
                <p className={styles.serviceGrades}>{workshop.grades}</p>
                <div className={styles.serviceDescription}>
                  {workshop.description.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
